import { DateTime } from "luxon";

type formatTypes =
  | "dd-MM-yyyy hh:mm:ss"
  | "dd-MM-yyyy, hh:mm a"
  | "dd-MM-yyyy"
  | "yyyy-MM-dd"
  | "yyyy-MM-dd hh:mm:ss"
  | "yyyy-MM-dd hh:mm:ss a"
  | "yyyy-MM-dd HH:mm:ss"
  | "yyyy-MM-dd HH:mm:ss a"
  | "relative"
  | "MMM d, h:mm a"
  | "MMM d"
  | "d MMM yy";

const formatDate = (
  value: string,
  format: formatTypes = "dd-MM-yyyy"
): string => {
  if (!DateTime.fromISO(value).isValid) {
    return value;
  }
  return DateTime.fromISO(value).toFormat(format);
};
const formatJsDate = (value: string): string => {
  return DateTime.fromJSDate(new Date(value)).toFormat("d-MMM");
};
const formatJsDateInDateMonthYear = (value: string): string => {
  return DateTime.fromJSDate(new Date(value)).toFormat("dd MMM yyyy");
};
const formatForInput = (date: Date) => {
  const pad = (n: number) => n.toString().padStart(2, "0");
  return (
    date.getFullYear() +
    "-" +
    pad(date.getMonth() + 1) +
    "-" +
    pad(date.getDate())
  );
};
function convertIsoToMonthNameDate(isoString: string) {
  const date = new Date(isoString);
  const formattedDate = date.toLocaleString("default", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });
  return formattedDate;
}
export {
  formatDate,
  formatJsDate,
  formatJsDateInDateMonthYear,
  formatForInput,
  convertIsoToMonthNameDate,
};
